import { useState } from "react";
import { Link, useHistory } from "react-router-dom";
import { auth, firestore, storage } from "../firebase";
import { useUserProvider } from "../context/UserProvider";
import CurrentUser from "./CurrentUser";

import { toast } from "react-toastify"; // then this

import {
  CssBaseline,
  Container,
  Box,
  Card,
  Divider,
  CardContent,
  Typography,
  Button,
  TextField,
  Stack,
  IconButton,
  ButtonBase,
  CardHeader,
} from "@mui/material";

import LoadingButton from "@mui/lab/LoadingButton";

import PhotoCamera from "@mui/icons-material/PhotoCamera";
import SaveIcon from "@mui/icons-material/Save";
import AttachFileIcon from "@mui/icons-material/AttachFile";

import { styled } from "@mui/material/styles";
const Input = styled("input")({
  display: "none",
});

const UserProfile = () => {
  const [displayName, setDisplayName] = useState("");
  const [imageInput, setImageInput] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [activeButton, setActiveButton] = useState(true);

  const history = useHistory("");

  const getUid = () => auth.currentUser.uid;

  const handleChange = (e) => {
    // e.preventDefault();
    if (e.target.files[0]) {
      setImageInput(e.target.files[0]);
      setActiveButton(false);
    }
  };

  const handleInput = (e) => {
    // e.preventDefault();
    setDisplayName(e);
    if (!displayName) {
      setActiveButton(true);
    } else {
      setActiveButton(false);
    }
  };

  function sleeper(ms) {
    return function (x) {
      return new Promise((resolve) => setTimeout(() => resolve(x), ms));
    };
  }

  const handleSubmit = (e) => {
    e.preventDefault();
    // console.log(imageInput.name);
    if (displayName) {
      setIsLoading(true);
      console.log(isLoading);
      firestore
        .doc(`users/${getUid()}`)
        .update({ displayName })
        .then(() => {
          setIsLoading(false);
          setActiveButton(true);
        });
      // Alert.success("Display Name Updated", 3000);
      toast.success("Display Name Updated", {
        theme: "colored",
      });
      setDisplayName("");
    }

    if (imageInput) {
      setIsLoading(true);
      storage
        .ref()
        .child("user-profiles")
        .child(getUid())
        .child(imageInput.name)
        .put(imageInput)
        .then((response) => response.ref.getDownloadURL())
        .then((photoURL) =>
          firestore.doc(`users/${getUid()}`).update({ photoURL })
        )
        .then(() => {
          // Alert.success("Image Updated");
          toast.success("Image Updated", {
            theme: "colored",
          });
          setImageInput(null);
          setIsLoading(false);
          setActiveButton(true);
        });
      // .then(sleeper(1000))
      // .then(() => {
      //   history.push("/");
      // });
    }
  };
  const { user } = useUserProvider();
  return (
    <Container size="sm">
      <CssBaseline />
      <CurrentUser {...user} />
      <Card>
        <CardContent>
          <Typography
            gutterBottom
            variant="h4"
            color="textSecondary"
            component="div"
          >
            Update Profile
          </Typography>
        </CardContent>
        <Divider />
        <CardContent>
          <form onSubmit={handleSubmit}>
            <Stack mt={1} spacing={1}>
              <Typography variant="h6" component="h6" gutterBottom>
                Choose Name
              </Typography>
              <TextField
                name="name"
                label="Display Name"
                value={displayName}
                onChange={(e) => handleInput(e.target.value)}
                // onChange={(e) => setEmail(e.target.value)}
              />
            </Stack>
            <Stack mt={5} spacing={1}>
              <Typography variant="h6" component="h6" gutterBottom>
                Upload Profile Picture
              </Typography>
              <Stack direction="row" mt={2} spacing={2}>
                <Button variant="contained" component="label" color="info">
                  {/* {" "} */}
                  <AttachFileIcon />
                  Upload a image
                  <input
                    type="file"
                    style={{ marginBottom: "1rem" }}
                    onChange={handleChange}
                    hidden
                  ></input>
                </Button>
              </Stack>
            </Stack>
            <Stack
              direction="row"
              justifyContent="space-between"
              mt={3}
              spacing={0}
            >
              <LoadingButton
                // loading
                loadingPosition="start"
                startIcon={<SaveIcon />}
                // variant="outlined"
                variant="contained"
                loading={isLoading ? true : false}
                type="submit"
              >
                Update
              </LoadingButton>

              <Link to="/">Back to Home</Link>
            </Stack>
          </form>
        </CardContent>
      </Card>
    </Container>
  );
};

export default UserProfile;
